import React from 'react';
import { classNames } from '../utils';

export type ButtonVariant = 'primary' | 'secondary' | 'text';

export function getBaseClasses(variant: ButtonVariant) {
  switch (variant) {
    case 'primary':
      return 'text-white bg-morton-600 hover:bg-morton-700 focus:border-morton-300 active:bg-morton-800';
    case 'secondary':
      return 'border-[1px] border-morton-600 bg-white text-morton-600 hover:bg-morton-50 focus:border-morton-600 active:bg-morton-100';
    case 'text':
      return 'border-none text-morton-600 bg-white hover:bg-morton-50 active:bg-morton-100 ';
    default:
      return '';
  }
}

export function getDisabledClasses(variant: ButtonVariant) {
  switch (variant) {
    case 'primary':
      return 'cursor-default bg-sidewalk-50 text-sidewalk-200 hover:bg-sidewalk-50 focus:border-none active:bg-sidewalk-50';
    case 'secondary':
      return 'cursor-default bg-white text-sidewalk-200 hover:bg-white focus:border-sidewalk-200 active:bg-white border-sidewalk-200 active:bg-white ';
    case 'text':
      return 'cursor-default bg-white text-sidewalk-200 hover:bg-white active:bg-white';
    default:
      return '';
  }
}

export const Button: React.FC<{
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  disabled?: boolean;
  children: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  fontClassName?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
}> = ({
  className,
  children,
  type,
  disabled,
  variant = 'primary',
  leftIcon,
  rightIcon,
  onClick,
  onMouseDown,
  fontClassName = 'typo-button',
}) => {
  return (
    <button
      className={classNames(
        'text-uppercase h-[40px] rounded-[80px] px-[22px] font-bold',
        getBaseClasses(variant),
        disabled ? getDisabledClasses(variant) : '',
        fontClassName,
        className
      )}
      type={type}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={(e) => {
        if (onMouseDown) {
          onMouseDown(e);
        }
      }}
    >
      {leftIcon}
      {children}
      {rightIcon}
    </button>
  );
};
